import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Tab, TabPane } from "semantic-ui-react"
import SearchOnMap from "../FuelStation/SearchOnMap"
import ShopSearch from "../Schedule/Shop/ShopSearch"
import { ACTIVE_VIEWS } from "../../../shared_component/constants/checkout"
import { getFuelcardUsaaFlag } from "../../../v1/constants/fuelcardRequest"
import { isUsaaUser } from "../../../v1/helpers/affiliationHelpers"

const SwitchMap = ({ defaultActiveIndex, user }) => {
  const { t } = useTranslation("fuelStation")
  const index = defaultActiveIndex != null ? defaultActiveIndex : 0
  const [usaaFlag, setUsaaFlag] = useState(false)

  const panes = [
    {
      menuItem: t("allServices"),
      render: () => (
        <TabPane attached={false}>
          <ShopSearch activeView={ACTIVE_VIEWS.MAP} count={2} showShopTiles={false} />
        </TabPane>
      )
    },
    {
      menuItem: t("getFuel"),
      render: () => (
        <TabPane attached={false}>
          <SearchOnMap />
        </TabPane>
      )
    }
  ]

  const handleFuelCardSplitFlag = async () => {
    try {
      const flag = await getFuelcardUsaaFlag()
      setUsaaFlag(flag)
    } catch (error) {
      console.log("Error in handleFuelCardFlag", error)
    }
  }

  useEffect(() => {
    handleFuelCardSplitFlag()
  }, [user])

  return (
    <div className="switch-map">
      {usaaFlag && isUsaaUser(user) ? (
        <Tab menu={{ secondary: true }} panes={panes} defaultActiveIndex={index} />
      ) : (
        <div className="default-map">
          <ShopSearch activeView={ACTIVE_VIEWS.MAP} count={2} showShopTiles={false} />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(SwitchMap)
